module.exports = __webpack_public_path__ + "static/3-d82831d26f2d5d47032941b0edafa29c.jpeg";